export const setProjectList = (state, payload) => {
	state.projectList = payload;
}

export const setProjectStatusList = (state, payload) => {
    var tempStatusList = [];
	for( var k in payload ) {
		tempStatusList.push({text: payload[k].description, obj: payload[k]});
	}
    state.projectStatusList = tempStatusList;
}

export const setObjProjectStatusEdit = (state, payload) => {
    for( let k in state.projectStatusList ) {
        if( state.projectStatusList[k].obj.id === payload.id ) {
            var statusString = JSON.stringify(state.projectStatusList[k]);
            statusString = statusString.replace(new RegExp('"No"', 'g'), false);
            statusString = statusString.replace(new RegExp('"Yes"', 'g'), true);
            var statusObj = JSON.parse(statusString);
            state.objProjectStatusEdit = statusObj;
        }
    }
}

export const setProjectSpecifiers = (state, payload) => {
	var objUsers = [];
	for ( var k in payload ) {
		if (payload[k].user_id != 0) {
			if (objUsers[payload[k].company_id] == null ) {
				objUsers[payload[k].company_id] = [];
			}
			objUsers[payload[k].company_id].push(payload[k] );
		}
	}
	var objPayload = [];
	for (var k in objUsers) {
		for (var n in objUsers[k]) {
			objPayload.push(objUsers[k][n] );
		}
	}
	var project_specifier_data = [];
	var current_company = null;
	for (var k in objPayload) {
		if (objPayload[k].user_id != 0) {
			if (current_company != objPayload[k].company_id) {
				var company_item = { name: '<strong>' + objPayload[k].company_name + '</strong>', id: objPayload[k].company_id, selectable: true, class: "company", type: 'Company' };
				if (objPayload[k].company_name != 'No Specifier Assigned') {
					project_specifier_data.push(company_item);
					current_company = objPayload[k].company_id;
				}
			}
			var user_item = { name: ' - ' + objPayload[k].user_name, id: objPayload[k].user_id, selectable: true, class: (objPayload[k].user_id == 0 ? "normal" : "user"), child_of: current_company, type: 'User' };
			project_specifier_data.push(user_item);
		}
	}

	state.projectSpecifiers = project_specifier_data;
}

export const setProjectVehicles = (state, payload) => {
	var tmpVehicles = [];
	for( var k in payload ) {
		tmpVehicles.push({
			id: payload[k].id,
			name: payload[k].name,
			excluded: payload[k].excluded,
			isChecked: false
		})
	}
	state.projectVehicles = tmpVehicles;
}
export const setProjectImage = (state, payload) => {
	var newImage = { source: payload, caption: '' };
	state.projectImages.push(newImage);
}

export const setEditProjectImage = (state, payload) => {
	var newImage = { source: payload, caption: '' };
	state.projectEditImages.push(newImage);
}

export const fncResetProjectStatus = (state, payload) => {
	state.projectStatusList.splice(payload.newIndex, 0, state.projectStatusList.splice(payload.oldIndex, 1)[0]);
	for (var k in state.projectStatusList) {
		state.projectStatusList[k].order = parseInt(k) + 1;
		state.projectStatusList[k].obj.order = parseInt(k) + 1;
	}
}

export const fncSetProjectStatus = (state, payload) => {
	state.projectStatusList = [];
}

export const setProjectRegions = (state, payload) => {
	var objTypes = [];
	if ( payload.Province.length > 0 ) {
		objTypes.push('province');
	}
	if (payload.District.length > 0) {
		objTypes.push('district');
	}
	if (payload.Town.length > 0) {
		objTypes.push('town');
	}
	state.projectRegionTypes = objTypes;
	var projectRegions = [];
	for (var k in payload.Country) {
		if (payload.Country[k].attr.name != '') {
			projectRegions.push({ id: payload.Country[k].attr.id, name: payload.Country[k].attr.name, children: [] });
		}
	}
	/*if (payload.Province.length > 0) {
		for (var p in payload.Province) {
			for (var k in userRegions) {
				if (projectRegions[k].id == payload.Province[p].parent) {
					if (payload.Town.length > 0) {
						projectRegions[k].children.push({ id: payload.Province[p].id, name: payload.Province[p].name, loc_id: payload.Province[p].loc_id, children: [] });
					} else {
						projectRegions[k].children.push({ id: payload.Province[p].id, name: payload.Province[p].name, loc_id: payload.Province[p].loc_id });
					}
				}
			}
		}
		if (payload.Town.length > 0) {
			for (var u in projectRegions) {
				for (var up in projectRegions[u].children) {
					for (var t in payload.Town) {
						if (payload.Town[t].parent == projectRegions[u].children[up].loc_id) {
							projectRegions[u].children[up].children.push({ id: payload.Town[t].id, name: payload.Town[t].name, loc_id: payload.Town[t].loc_id });
						}
					}
				}
			}
		}

	} else if (payload.District.length > 0) {

	}*/
	state.projectRegions = projectRegions;
}

export const setProjectRegionSub = (state, payload) => {
	var projectSub = [];
	for (var k in payload) {
		if (payload[k].name != '') {
			projectSub.push({ id: payload[k].attr.id, name: payload[k].attr.name });
		}
	}
	state.projectRegionSub = projectSub;
}

export const setProjectRegionSubSub = (state, payload) => {
	var projectSub = [];
	for (var k in payload) {
		if (payload[k].name != '') {
			projectSub.push({ id: payload[k].attr.id, name: payload[k].attr.name });
		}
	}
	state.projectRegionTown = projectSub;
}

export const setObjProjectEdit = (state, payload) => {
	state.projectEditImages = payload.images;
	state.objProjectEdit = payload;
}

export const setProjectPreLocations = (state, payload) => {
	state.projectPreLocations = payload;
}

export const fncEmptyAddressSelection = (state, payload) => {
	state.projectRegionSub = [];
	state.projectRegionTown = []
}

export const fncEmptyProjects = (state, payload) => {
	state.projectList = [];
}

export const setProjectTenderWinner = (state, payload) => {
	state.projectTenderWinner = payload;
}
export const selectedNewLeadProject = (state, payload) => {
	state.selectedNewLeadProject = payload;
}
